/**
 * @flow
 * @author: Pavan
 */
import Colors from '../../themes/Colors'

export const placeholderColor = Colors.blueyGreyThree
export const focussedTextColor = Colors.lightNavyThree
export const borderColor = Colors.lightBlueGreyThree
export const errorBorderColor = Colors.dullRed
export const focussedBorderColor = Colors.lightNavyThree
export const textInputBackgroundColor = Colors.iceBlue
export const mobileDateInputWidth = 280
export const defaultDateInputWidth = 220



// WEBPACK FOOTER //
// ./src/commons/BaseDateField/themeConstants.js